import React, { useCallback } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Text } from 'components/ui';
import RewardsCarousel from 'components/Content/BeautyInsider/RewardsCarousel';
import BiRewardButton from 'components/Content/BeautyInsider/BiRewardButton';
import anaConstants from 'analytics/constants';

const BeautyInsiderMissedRewards = props => {
    const {
        missedRewards, isAnonymous, localization, basket
    } = props;

    const renderBiButton = useCallback(({ analyticsContext, sku }) => (
        <BiRewardButton
            sku={sku}
            analyticsContext={analyticsContext}
            isAnonymous={isAnonymous}
            basket={basket}
        />
    ), [isAnonymous, basket]);

    if (!missedRewards || missedRewards.length === 0) {
        return null;
    }

    return (
        <React.Fragment>
            <Box marginBottom={[6, null, 6]} marginTop={[4, null, 4]}>
                <Text
                    is='h3'
                    fontWeight='bold'
                    fontSize={['md', null, 'lg']}
                    marginBottom={4}
                >
                    {localization.youJustMissedThese}
                </Text>
                <RewardsCarousel
                    items={missedRewards}
                    title={localization.youJustMissedThese}
                    showPrice={true}
                    showMarketingFlags={true}
                    size='small'
                    rougeBadgeText={localization.rougeBadge}
                    analyticsContext={anaConstants.CONTEXT.BASKET_REWARDS}
                    renderBiButton={renderBiButton}
                    hideVariationText={true}
                />
            </Box>
        </React.Fragment>
    );
};

export default wrapFunctionalComponent(BeautyInsiderMissedRewards, 'BeautyInsiderMissedRewards');
